export default {
	content: {},
	commonContent: {}
};
